// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M4.33338 4.99948C4.33367 3.34283 5.67673 2 7.33338 2H13.0004V4H7.33338C6.78117 4 6.33348 4.44761 6.33338 4.99983L6.33226 11.5H4.33997L0.585938 7.44565L2.05346 6.08683L4.33277 8.54849L4.33338 4.99948ZM7.99911 6H22.9991V21H7.99911V6Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-anticlockwise-filled')
export default class AnticlockwiseFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'anticlockwise-filled',
    }
  }
}
